import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "universal-cookie";
import apiError from "@/errors/api.error";
import {
  addErrorNotification,
  addInfoNotification,
} from "@/components/framework/notify";

export default () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["movePersonalFolder"],
    mutationFn: async ({ from, to }) => {
      try {
        await axios.put(
          `/api/gateway/personal-documents/folders/${encodeURIComponent(from)}`,
          { folderPath: to },
          {
            headers: {
              authorization: `Bearer ${new Cookies().get("accessToken")}`,
            },
          },
        );
      } catch (e) {
        throw apiError.create(e.response.data.message);
      }
    },
    onSuccess: () => {
      // Invalidate and refetch personal documents
      queryClient.invalidateQueries(["personalDocuments"]);

      addInfoNotification({
        tid: "success",
      });
    },
    onError: (error) => {
      addErrorNotification({
        tid: "generic.unknown_error",
        message: error.message,
      });
    },
  });
};
